import React, { useEffect, useState, useRef } from 'react';
import {
    external1, arrowimg, boost_bg,
    //  account_step, account_step2, account_step3, account_step4,
    arrow, card1, card4, card_vector, carduser1, carduser2, carduser3, circle1, circle2, halfstar, join_img1, join_img2, onestart, start, logo, bridge_icon1, bridge_icon2, bridge_icon3, bridge_icon4, footer_logo, about_left_img, rcm_logo, rcm_logo2, dentist,
    entre, shipping, topview, wiretransfer, gridentcolor, rcmapart, phone, inbox,
    dottesti
} from '../../assets/images';
import { Accordion, Button, Card, Carousel, Modal, Container, Row, Col } from 'react-bootstrap';
import 'uikit/dist/css/uikit.min.css';
import 'uikit/dist/js/uikit.min.js';
import 'uikit/dist/js/uikit-icons.min.js'; // Optional if you want to use icons
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { getContactApiUrl } from '../../config/api';
// import { Container, Row, Col, Accordion, Button } from "react-bootstrap";

import { Link } from 'react-router-dom';
import { ImArrowRight2, ImArrowUpRight2 } from 'react-icons/im';
// import { Accordion } from "react-bootstrap";

import { FaPlus, FaMinus } from "react-icons/fa";
import { trackGAEvent, GA_EVENTS } from '../../utils/googleAnalytics';

const testimonials = [
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
    {
        title: 'Exceptional Service and Accuracy',
        quote: 'ProBill RCM has truly transformed our billing process. Their payment posting services are quick and accurate, and we’ve seen a significant improvement in our cash flow. The team is professional, responsive, and detail-oriented. Highly recommend!"– Dr. Sarah Thompson, Healthcare Clinic',
        name: "Wade Warren",
        role: "",
        rating: 4.3,
        img: carduser1, // You can replace this with actual images
    },
    {
        title: 'Efficient and Reliable',
        quote: "Working with ProBill RCM has been a game-changer for our practice. Their team handles everything from denial management to insurance payments seamlessly. Our revenue cycle has never been smoother, and their efficiency has saved us both time and money– John Myers, Practice Manager.",
        name: "Sophie Reynolds",
        role: "",
        rating: 4.2,
        img: carduser2,
    },
    {
        title: 'Outstanding Denials Management',
        quote: 'We struggled with managing claim denials before partnering with ProBill RCM. Their expertise in appeals and denial management has helped us recover significant revenue we would have otherwise lost. Excellent service all around!"– Lisa Perez, Medical Billing Specialist ',
        name: "David Mitchell",
        role: "",
        rating: 4.1,
        img: carduser3,
    },
];

const Section = () => {
    const sectionRefs = useRef([]);
    const containerRef = useRef();
    const [animatedSections, setAnimatedSections] = useState(new Set());
    const [hasAnimated, setHasAnimated] = useState(new Set());
    const CARD_WIDTH =
        window.innerWidth < 768
            ? 335
            : window.innerWidth < 1024
                ? 350
                : window.innerWidth < 1200
                    ? 400
                    : window.innerWidth < 1500
                        ? 450
                        : window.innerWidth < 1700
                            ? 500
                            : window.innerWidth < 1800
                                ? 568
                                : 625;

    // Create infinite loop by tripling testimonials for seamless loop
    const infiniteTestimonials = [...testimonials, ...testimonials, ...testimonials];

    const groupedTestimonials = [];
    for (let i = 0; i < testimonials.length; i += 3) {
        groupedTestimonials.push(testimonials.slice(i, i + 3));
    }

    const [currentIndex, setCurrentIndex] = useState(0);
    const [visibleCards, setVisibleCards] = useState(3);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    const updateVisibleCards = () => {
        setVisibleCards(3);
    };

    const [activeKey1, setActiveKey1] = useState("0");
    const [activeKey2, setActiveKey2] = useState("0");

    // Toggle functions for each
    const toggleKey1 = (key) => {
        setActiveKey1(activeKey1 === key ? null : key);
    };

    const toggleKey2 = (key) => {
        setActiveKey2(activeKey2 === key ? null : key);
    };

    useEffect(() => {
        updateVisibleCards();
        window.addEventListener('resize', updateVisibleCards);

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const index = entry.target.dataset.sectionIndex;
                    if (index) {
                        const sectionIndex = parseInt(index);
                        if (entry.isIntersecting && !hasAnimated.has(sectionIndex)) {
                            setAnimatedSections(prev => new Set([...prev, sectionIndex]));
                            setHasAnimated(prev => new Set([...prev, sectionIndex]));
                        }
                    }
                });
            },
            { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        );

        sectionRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            window.removeEventListener('resize', updateVisibleCards);
            observer.disconnect();
        };
    }, []);

    // Autoplay functionality - continuous infinite scroll
    useEffect(() => {
        if (!isAutoPlaying) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                const nextIndex = prevIndex + 1;
                // Seamlessly loop back when reaching the end of first set
                if (nextIndex >= testimonials.length) {
                    return 0;
                }
                return nextIndex;
            });
        }, 4500);

        return () => clearInterval(interval);
    }, [isAutoPlaying]);

    const handleNext = () => {
        setIsAutoPlaying(false); // Stop autoplay when user interacts
        setCurrentIndex((prevIndex) =>
            prevIndex < testimonials.length - visibleCards ? prevIndex + 1 : prevIndex
        );
    };

    const handlePrev = () => {
        setIsAutoPlaying(false); // Stop autoplay when user interacts
        setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
    };
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => {
        setShowModal(false);
        setIsSubmitted(false);
    };
    const handleShow = () => setShowModal(true);
    const [activeAccordion, setActiveAccordion] = useState(null);
    const handleAccordionToggle = (eventKey) => {
        setActiveAccordion(prev => (prev === eventKey ? null : eventKey));
    }
    // const getImageToShow = () => {
    //     switch (activeAccordion) {
    //         case "0":
    //             return account_step2;
    //         case "1":
    //             return account_step3;
    //         case "2":
    //             return account_step4;
    //         case "3":
    //             return account_step5;
    //         default:
    //             return account_step;
    //     }
    // };
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        mode: "onChange", // Enables real-time validation
    });


    const [navbarColor, setNavbarColor] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = async (data) => {
        setIsSubmitting(true);

        try {
            const response = await axios.post(getContactApiUrl(), {
                fullName: data.fullName,
                email: data.email,
                subject: data.subject || 'Home Page Contact',
                message: data.message,
            });

            if (response.data.success) {
                setIsSubmitted(true);
                reset();
            }
        } catch (error) {
            console.error("Error sending email: ", error);
        } finally {
            setIsSubmitting(false);
        }
    };
    useEffect(() => {
        window.scrollTo(0, 0);

        const changeNavbarColor = () => {
            if (window.scrollY >= 80) {
                setNavbarColor(true);
            } else {
                setNavbarColor(false);
            }
        };

        const handleScroll = () => {
            const section = document.querySelector(".industry-cards-containers");
            if (!section) return;

            const rect = section.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const progress = 1 - rect.top / windowHeight;
            const clamped = Math.max(0, Math.min(1, progress));
            const maxTranslate = 100;

            document.querySelectorAll(".industry-column-11 .industry-card").forEach((el) => {
                el.style.transform = `translateY(${clamped * maxTranslate}px)`;
            });

            document.querySelectorAll(".industry-column-12 .industry-card").forEach((el) => {
                el.style.transform = `translateY(-${clamped * maxTranslate}px)`;
            });
        };

        window.addEventListener('scroll', changeNavbarColor);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', changeNavbarColor);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <style>{`
                .animate-section[data-section-index="0"] {
                    opacity: 0;
                    transform: translateY(50px) scale(0.95);
                    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                }
                .animate-section[data-section-index="0"].visible {
                    opacity: 1 !important;
                    transform: translateY(0) scale(1) !important;
                }
                .animate-section[data-section-index="1"] {
                    opacity: 0;
                    transform: translateX(-40px) rotateY(5deg);
                    transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.2s;
                }
                .animate-section[data-section-index="1"].visible {
                    opacity: 1 !important;
                    transform: translateX(0) rotateY(0deg) !important;
                }
                .animate-cards {
                    opacity: 0;
                    transform: translateY(60px) scale(0.9);
                    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;
                }
                .animate-cards.visible {
                    opacity: 1 !important;
                    transform: translateY(0) scale(1) !important;
                }
                .animate-section[data-section-index="3"] {
                    opacity: 0;
                    transform: translateY(70px) scale(0.92);
                    transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.4s;
                }
                .animate-section[data-section-index="3"].visible {
                    opacity: 1 !important;
                    transform: translateY(0) scale(1) !important;
                }
                .animate-section[data-section-index="4"] {
                    opacity: 0;
                    transform: translateY(55px) scale(0.96);
                    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;
                }
                .animate-section[data-section-index="4"].visible {
                    opacity: 1 !important;
                    transform: translateY(0) scale(1) !important;
                }
                .animate-section[data-section-index="5"] {
                    opacity: 0;
                    transform: translateX(35px) rotateY(-3deg);
                    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.6s;
                }
                .animate-section[data-section-index="5"].visible {
                    opacity: 1 !important;
                    transform: translateX(0) rotateY(0deg) !important;
                }
                .animate-section[data-section-index="6"] {
                    opacity: 0;
                    transform: translateY(45px) scale(0.97);
                    transition: all 0.5s ease-out 0.7s;
                }
                .animate-section[data-section-index="6"].visible {
                    opacity: 1 !important;
                    transform: translateY(0) scale(1) !important;
                }
                .animate-section[data-section-index="7"] {
                    opacity: 0;
                    transform: translateX(-30px) rotateY(4deg);
                    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.8s;
                }
                .animate-section[data-section-index="7"].visible {
                    opacity: 1 !important;
                    transform: translateX(0) rotateY(0deg) !important;
                }
                .animate-section[data-section-index="8"] {
                    opacity: 0;
                    transform: translateY(40px) scale(0.98);
                    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.9s;
                }
                .animate-section[data-section-index="8"].visible {
                    opacity: 1 !important;
                    transform: translateY(0) scale(1) !important;
                }
                .animate-section[data-section-index="9"] {
                    opacity: 0;
                    transform: translateX(25px) rotateY(-2deg);
                    transition: all 0.7s ease-in-out 1s;
                }
                .animate-section[data-section-index="9"].visible {
                    opacity: 1 !important;
                    transform: translateX(0) rotateY(0deg) !important;
                }
                .animate-section[data-section-index="10"] {
                    opacity: 0;
                    transform: translateY(35px) scale(0.99);
                    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 1.1s;
                }
                .animate-section[data-section-index="10"].visible {
                    opacity: 1 !important;
                    transform: translateY(0) scale(1) !important;
                }
                .animate-section[data-section-index="11"] {
                    opacity: 0;
                    transform: translateY(30px) scale(0.99);
                    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 1.2s;
                }
                .animate-section[data-section-index="11"].visible {
                    opacity: 1 !important;
                    transform: translateY(0) scale(1) !important;
                }
                .btn {
                    transition: all 0.3s ease;
                    transform: translateY(0);
                }
               
                .add_hover_effect {
                    transition: all 0.3s ease;
                }
                .add_hover_effect:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 15px 35px rgba(0,0,0,0.15);
                }
                .card {
                    transition: all 0.3s ease;
                }
                .card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 20px 40px rgba(0,0,0,0.1);
                }
                .industry-card:hover {
                    transform: translateY(-10px) scale(1.02);
                    box-shadow: 0 25px 50px rgba(0,0,0,0.15);
                }
                
                /* Mobile Responsive Styles */
                @media (max-width: 768px) {
                    .hero-text {
                        font-size: 1.8rem !important;
                        line-height: 1.3 !important;
                    }
                    .lead {
                        font-size: 0.95rem !important;
                        width: 95% !important;
                    }
                    .mx-5 {
                        margin-left: 1rem !important;
                        margin-right: 1rem !important;
                    }
                    .card-width {
                        width: 100% !important;
                        max-width: 280px !important;
                    }
                    .floting-card-title {
                        font-size: 0.9rem !important;
                    }
                    .floting-card-desc {
                        font-size: 0.8rem !important;
                    }
                    .add_grident_font {
                        font-size: 20px !important;
                    }
                    .boost {
                        font-size: 2rem !important;
                    }
                    .add_font_revenue {
                        font-size: 1.2rem !important;
                    }
                    .any-para {
                        font-size: 0.9rem !important;
                    }
                    .revenue-circle {
                        font-size: 0.85rem !important;
                    }
                    .contact-text {
                        font-size: 1.5rem !important;
                        line-height: 1.3 !important;
                    }
                    .bridge-img-desc {
                        width: 95% !important;
                        font-size: 0.9rem !important;
                    }
                    .setu {
                        font-size: 0.9rem !important;
                    }
                    .bridge-card-title {
                        font-size: 1rem !important;
                    }
                    .bridge-card-desc {
                        font-size: 0.85rem !important;
                    }
                    .setu-first-l {
                        font-size: 28px !important;
                    }
                  
                    .add_heading_industry {
                        font-size: 1rem !important;
                        line-height:18px!important
                    }
                    .add_para_industry {
                        font-size: 0.7rem !important;
                        line-height:16px!important
                    }
                    .text-probill-rcm {
                        font-size: 1.4rem !important;
                    }
                    .text-probill-para {
                        font-size: 0.9rem !important;
                    }
                    .card-heading {
                        font-size: 1.1rem !important;
                    }
                    .insight-desc {
                        font-size: 0.85rem !important;
                    }
                    .card-user-name {
                        font-size: 0.9rem !important;
                    }
                    .card-rating {
                        font-size: 0.8rem !important;
                    }
                    .stat-title {
                        font-size: 1rem !important;
                    }
                    .add_font_size {
                        font-size: 1.8rem !important;
                    }
                    .stat-text {
                        font-size: 0.95rem !important;
                    }
                    .faq-subtitle {
                        font-size: 0.9rem !important;
                    }
                    .add_font_bg_section {
                        font-size: 12px !important;
                        line-height: 17px!important;

                    }
                    .industry-column-12 {
                        margin-top: 1rem !important;
                    }
                    .newEmpowering {
                        flex-direction: column !important;
                    }
                    .exprence {
                        border-right: none !important;
                        border-bottom: 1px solid #dee2e6 !important;
                        padding-bottom: 1rem !important;
                        margin-bottom: 1rem !important;
                    }
                    .exprence:last-child {
                        border-bottom: none !important;
                        margin-bottom: 0 !important;
                    }
                    .bg-img-bridge {
                        width: 100% !important;
                        height: 200px !important;
                        background-size: contain !important;
                    }
                  
                
                    .stat-card {
                        margin-bottom: 0.7rem !important;
                    }
                    .doctor-card img {
                        max-height: 300px !important;
                        object-fit: cover !important;
                    }
                    .accordion_second {
                        font-size: 12px !important;
                    }
                    .modal-heading h1 {
                        font-size: 1.5rem !important;
                    }
                    .custom_control {
                        font-size: 0.9rem !important;
                    }
                }
                
                @media (max-width: 576px) {
                    .hero-text {
                        font-size: 1.5rem !important;
                    }
                    .contact-text {
                        font-size: 1.3rem !important;
                    }
                    .add_grident_font {
                        font-size: 20 !important;
                    }
                    .boost {
                        font-size: 1.8rem !important;
                    }
                    .card-width {
                        max-width: 250px !important;
                    }
                   
                  
                    .setu-first-l {
                        font-size: 24px !important;
                    }
                  
                }
            `}</style>
            <section className="hero-section text-center">
                <div
                    className={`container bg-bg animate-section ${animatedSections.has(0) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[0] = el}
                    data-section-index="0"
                >
                    <div className="row">
                        <div className="col-12 text-center">
                            <h1 className="hero-text">
                                Enhance  <span className="text-orange add_grident_font">Medical Billing.</span> <br />
                                Efficiency to Accelerate Revenue Cycles
                            </h1>
                        </div>
                    </div>
                </div>
                <div
                    className={`container-fluid bg-header-second animate-section ${animatedSections.has(1) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[1] = el}
                    data-section-index="1"
                >
                    <div className="container">
                        <div className="row mx-auto">
                            <div className="  col-lg-12 col-12 ">
                                <div className="mx-5 d-flex justify-content-center">
                                    <p className="lead  w-75  " >
                                        We build intelligent, scalable digital solutions that improve patient care, streamline operations, and future-proof the healthcare development services you rely on.</p>
                                </div>
                                {/* <button className="bt border-0 btn-warning position-relative  mt-3 mb-md-5 " type="submit" onClick={handleShow} > Contact Us</button> */}
                                <button
                                    className="btn add_padding_font"
                                    onClick={() => {
                                        handleShow();
                                        trackGAEvent(GA_EVENTS.HOME_LETS_CONNECT, 'CTA', 'Hero Section');
                                    }}
                                    type="button"
                                    style={{
                                        position: "relative",
                                        zIndex: 10,
                                        background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                        color: "white",
                                        borderRadius: "12px",
                                        padding: "10px 30px",
                                        border: "none",
                                        fontWeight: "500",
                                        fontSize: "16px",
                                        // boxShadow: "0 2px 8px rgba(233, 114, 14, 0.3)"
                                    }}
                                >
                                    Let's Connect
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={`row mx-auto card-bg-img mt-lg-0 mt-1 p-0 animate-cards ${animatedSections.has(2) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[2] = el}
                    data-section-index="2"
                    style={{ pointerEvents: "none" }}
                >
                    <div className=" col-6 mt-lg-0 mt-2 d-flex flex-lg-row justify-content-lg-center justify-content-evenly align-items-center pe-1">
                        <div
                            className="card card-width card-rotate p-md-3 p-1"
                        >
                            <img
                                src={card1}
                                className="img-fluid card-img-data mx-auto m-0"
                                alt=""
                                style={{ transform: 'rotate(0deg)' }} // Correct property for rotation
                            />
                            <p className="floting-card-title m-0">Enhance Patient Outcomes </p>
                            <p className="floting-card-desc mb-1 m-lg-0 text-muted px-1">
                                Deliver better care with intuitive tools that improve engagement and satisfaction.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 mt-lg-0 mt-2 col-6 d-flex  flex-lg-row justify-content-lg-center justify-content-evenly align-items-center ps-1">
                        <div
                            className="card card-width card-rotate-2 p-md-3 p-1 text-center"
                        >
                            <img
                                src={card4}
                                className="img-fluid card-img-data mx-auto m-0"
                                alt=""
                            />
                            <p className="floting-card-title m-0">Boost Efficiency & Revenue</p>
                            <p className="floting-card-desc mb-1 m-lg-0 text-muted px-1">
                                Streamline operations, reduce manual work, and accelerate revenue cycles.
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className={`boost_main animate-section ${animatedSections.has(3) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[3] = el}
                    data-section-index="3"
                >
                    <div className="container pt-lg-4 pt-3">
                        <div className="row mx-auto">
                            <div className="col-12 col-lg-6 d-flex flex-column justify-content-between align-items-center p-4">
                                <div className="d-lg-flex shadow p-0 mx-1 mb-2 mb-lg-3 add_hover_effect">
                                    <img src={join_img1} className='  add_width_height_img p-0' alt="Revenue Cycle Management Services" />
                                    <div className="div text-start mt-lg-4 p-3 px-4">
                                        <div className="card-title"> <img src={rcm_logo} className="img-fluid mt-lg-0 mt-1 mx-lg-0 join-logo  " alt="logo" style={{ objectFit: "contain" }} />  <img src={rcm_logo2} className="img-fluid mt-1  join-logo2 mx-lg-1" alt="logo" style={{ objectFit: "contain" }} /> <span className=''>Approach</span> </div>
                                        <div className="card-text pt-1 ">We simplify healthcare operations with a lean, automation-driven approach reducing errors, boosting accuracy, and speeding up payment cycles for better RCM performance.</div>

                                    </div>
                                </div>
                                <div className=" d-lg-flex shadow mx-1 mt-lg-0 m-0 mt-2 mt-md-0 p-0    add_hover_effect" >
                                    <img src={join_img2} className='  add_width_height_img p-0' alt="rcm healthcare services" />
                                    <div className="div text-start mt-lg-4 p-3 px-4">
                                        <div className="card-title ">Customer first Philisophy</div>
                                        <div className="card-text pt-1 ">We simplify complex healthcare operations using lean processes and smart automation. This approach minimizes errors, improves billing accuracy, and accelerates payment cycles.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 ps-lg-0 text-lg-end skills p-0 p-lg-0 mt-lg-0 mt-0">
                                <div className='row'>
                                    <div className='col-12'>
                                        <h2 className=' m-0 mt-lg-3 add_grident_font'>......10x</h2>
                                    </div>
                                    <div className='col-12 ps-lg-0 d-lg-flex align-items-center '>
                                        <div className='row mx-auto me-0'>
                                            <div className='col px-4 pe-0'>
                                                <img src={boost_bg} alt='' className='bg-line d-none d-lg-block' />
                                            </div>
                                            <div className='col-lg-auto col-12  pe-0'>
                                                <h2 className='boost   m-0'>Boost</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12  text-end'>
                                        <h2 className='fw-medium mb-4 mt-lg-1 add_font_revenue'>in Revenue & Efficiency </h2>
                                        <p className='any-para  mt-2 pt-lg-2 ms-lg-5 mb-4 text-end '>We empower healthcare teams with seamless Revenue Cycle Management (RCM) and smart credentialing support. Partnering with ProBill means gaining the expertise and tools to scale faster, earn more, and operate with confidence. </p>
                                        <button
                                            className="btn mt-0 add_padding_font"
                                            onClick={() => {
                                                handleShow();
                                                trackGAEvent(GA_EVENTS.HOME_GET_STARTED, 'CTA', 'Boost Section');
                                            }}
                                            type="button"
                                            style={{
                                                background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                                color: "white",
                                                borderRadius: "12px",
                                                padding: "10px 40px",
                                                border: "none",
                                                fontWeight: "500",
                                                fontSize: "16px",
                                                // boxShadow: "0 2px 8px rgba(233, 114, 14, 0.3)"
                                            }}
                                        >
                                            Get Started
                                        </button>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-lg-end p-md-2 p-0 mt-lg-2 mt-0 newEmpowering" >
                                    <div className="exprence mt-lg-3 p-0 p-lg-0 d-flex flex-md-column flex-row align-items-center align-items-md-end justify-content-lg-end justify-content-start  border-end px-lg-5 ps-0 text-lg-end">
                                        <div className="d-flex justify-content-lg-end">
                                            <div className="circle rounded-circle  d-flex justify-content-center align-items-center p-2">
                                                <img src={circle2} className='img-fluid circleimg' style={{ width: '47px', height: '47px' }} alt="" />
                                            </div>
                                        </div>
                                        <p className='revenue-circle text-start text-lg-end ps-3 ps-md-0'>Smarter RCM that cuts costs, minimizes errors, and frees up time for patient care.  </p>
                                    </div>
                                    <div className="exprence px-lg-3 mt-lg-3 p-0 p-lg-0 ps-0 ps-lg-0   pe-lg-0 px-0 px-lg-0  text-lg-end d-flex align-items-center align-items-md-end flex-md-column flex-row-reverse">
                                        <div className="d-flex justify-content-lg-end">
                                            <div className="circle rounded-circle p-2  d-flex justify-content-center align-items-center">
                                                <img src={circle1} className='img-fluid me-2 circleimg' style={{ width: '42px', height: 'auto' }} alt="" />
                                            </div>
                                        </div>
                                        <p className='revenue-circle text-end text-lg-end pe-3 pe-md-0'>Automated tools to speed up claims, minimize delays, and maximize revenue.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className={`bg-light mt-lg-5 pt-md-5 pt-0 mb-0 mb-lg-0 pb-md-0 pb-0 animate-section ${animatedSections.has(4) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[4] = el}
                    data-section-index="4"
                >
                    <div className="container mb-0 mb-lg-0 mt-lg-2">
                        <div className="row">

                            <div className=" col-12 p-0   ">
                                {/* <h1 className='text-probill-bridge d-none d-lg-block m-lg-0 ' style={{ top: '75px', fontSize: '48px', fontFamily: 'Oswald', fontWeight: '600' }}>Bridging the Gap
                            </h1> */}
                                <h2 class="text-dark contact-text  m-0 mt-lg-0 my-3 mt-4">Your Roadmap to <span class="contact-text-orange add_grident_font">Healthcare </span>  Optimization</h2>
                                {/* <h1 className='text-probill-rcm  d-lg-none mt-3' style={{ top: '35px' }}>Bridging the Gap
                            </h1> */}
                                {/* <div className="div d-flex justify-content-center span-line m-0"><span className="span-line mt-3 d-none d-lg-block mb-3" style={{ width: '190px', height: '5px', backgroundColor: '#f7941d' }}></span></div> */}
                                <div className="div d-flex justify-content-center">
                                    <p className='w-50 text-muted m-0 bridge-img-desc'>We work closely with healthcare professionals, combining real-world insight, smart technology, and tailored strategies to help them confidently navigate today’s complex challenges. </p>

                                </div>
                                <div className='d-flex justify-content-center mt-3'>
                                    <p className='setu fw-normal w-50  '><b>SETU: The Bridge</b> </p>

                                </div>


                                <div className="d-flex justify-content-center">
                                    <div className="div  bg-img-bridge"></div>

                                </div>
                            </div>
                        </div>
                        <div className="row mt-0 mt-lg-4 mb-lg-0 bridge-row">
                            <div className="col-6 col-lg-3 mt-0 mt-lg-0 mb-0  d-flex  justify-content-lg-center  justify-content-center px-0 ">
                                <div className="card-pillar1 border-0 bridge-card  bg-light  text-center px-md-4 px-4 pt-2">
                                    <div className="d-flex mb-lg-2 justify-content-center">
                                        <div className=' d-flex justify-content-center p-0 align-items-center' style={{ width: '65px', height: '60px', backgroundColor: '#272D40' }}>
                                            <h3 className='text-white setu-first-l  '
                                                style={{
                                                    margin: 0,
                                                    lineHeight: '60px', /* Matches the height of the container */
                                                    fontSize: '35px', /* Adjust font size if necessary */
                                                }}
                                            >S</h3>
                                        </div>

                                    </div>
                                    <h3 className="bridge-card-title mb-lg-1 mb-0 ">
                                        Sound Research
                                    </h3>
                                    <p className="bridge-card-desc pb-0 mb-0 mt-2 mt-md-3 text-center ">
                                        Committed to continuous research that predicts, refines, and strengthens healthcare processes.

                                    </p>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3 mt-0 mt-lg-0 d-flex  justify-content-lg-center justify-content-center  px-md-4 px-4 pt-2">
                                <div className="card-pillar2 border-0  bridge-card mt-lg-0 bg-light">
                                    <div className="d-flex mb-lg-2 justify-content-center">
                                        <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{
                                                width: '65px',
                                                height: '60px',
                                                backgroundColor: '#272D40',
                                            }}
                                        >
                                            <h3
                                                className="text-white setu-first-l"
                                                style={{
                                                    margin: 0,
                                                    lineHeight: '60px', /* Matches the height of the container */
                                                    fontSize: '35px', /* Adjust font size if necessary */
                                                }}
                                            >
                                                E
                                            </h3>
                                        </div>


                                    </div>
                                    <h3 className="bridge-card-title mb-lg-1 mb-0 ">
                                        Education
                                    </h3>
                                    <p className="bridge-card-desc pb-0 mb-0 mt-2 mt-md-3 text-center ">
                                        Equipping teams with up-to-date knowledge to stay ahead in an evolving medical landscape.                                </p>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3 mt-0 mt-lg-0 d-flex justify-content-lg-center justify-content-center px-md-4 px-4 pt-md-2 pt-0">
                                <div className="card-pillar3 border-0  bridge-card mt-2  mt-lg-0 bg-light">
                                    <div className="d-flex mb-lg-2 justify-content-center">
                                        <div className=' d-flex justify-content-center align-items-center' style={{ width: '65px', height: '60px', backgroundColor: '#272D40' }}>
                                            <h3 className='text-white setu-first-l d-flex justify-content-center align-items-center '
                                                style={{
                                                    margin: 0,
                                                    lineHeight: '60px', /* Matches the height of the container */
                                                    fontSize: '35px', /* Adjust font size if necessary */
                                                }}
                                            >T</h3>

                                        </div>

                                    </div>
                                    <h3 className="bridge-card-title mb-lg-1  mb-0">
                                        Tailored Approach
                                    </h3>
                                    <p className="bridge-card-desc pb-0 mb-0 text-center mt-2 mt-md-3 ">
                                        Every solution is custom-fit like a tailored suit aligned precisely with your needs and vision.                                 </p>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3 mt-0 mt-lg-0 d-flex justify-content-lg-center justify-content-center  px-md-4 px-4 pt-md-2 pt-0">
                                <div className="card-pillar4 mb-lg-0 mb-0 border-0  bridge-card mt-lg-0 mt-2  bg-light">
                                    <div className="d-flex justify-content-center">
                                        <div className=' d-flex justify-content-center align-items-center ' style={{ width: '65px', height: '60px', backgroundColor: '#272D40' }}>
                                            <h3 className='text-white  setu-first-l d-flex justify-content-center align-items-center '
                                                style={{
                                                    margin: 0,
                                                    lineHeight: '60px', /* Matches the height of the container */
                                                    fontSize: '35px', /* Adjust font size if necessary */
                                                }}
                                            >U</h3>

                                        </div>

                                    </div>
                                    <h3
                                        className="bridge-card-title  d-none d-lg-block"
                                        style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'visible', // Ensure no hidden overflow
                                            textOverflow: 'clip', // Ensure no text gets truncated
                                            display: 'inline-block', // Ensure it stays on one line
                                        }}
                                    >
                                        Ultimate Denial Management
                                    </h3>

                                    <p className="bridge-card-title d-lg-none mb-0 mb-md-4 ">
                                        Denial Management
                                    </p>
                                    <p className="bridge-card-desc pb-0 mb-0 d-flex m-lg-0 mt-2 mt-md-3 justify-content-center align-items-center text-center">
                                        Harnessing AI and machine learning to proactively manage and minimize claim denials.                                 </p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div className="frame mt-lg-0  ">
                    <div className="container mt-lg-1 ">
                        <div className="row mx-auto mt-0 mt-lg-0 py-md-5 pb-3">
                            <div className="col-lg-12 m-0 col-12  mt-0 pb-4 text-lg-center flex-column d-flex justify-content-center px-0">
                                <h2 className='text-white contact-text  m-0 mt-lg-0 mt-4'>
                                    Let’s Talk -<span className='contact-text-orange add_grident_font'> Get Personalized</span>  Insights

                                </h2>
                                <p className=' any-para mt-3 mt-lg-1 mb-0' style={{ color: 'rgba(255, 255, 255, 1)' }}>Partner with us to unlock smarter healthcare solutions.</p>
                            </div>
                            <div className="col-lg-12 col-12 mt-lg-0 pb-0 d-flex justify-content-lg-center justify-content-center align-items-lg-center px-0">
                                <button className="btn contact-btn-2 py-1 d-flex align-items-center justify-content-center">
                                    <a
                                        href="tel:+1 (216) 678-6887"
                                        className='nav-link text-decoration-none px-0 p-0 d-flex align-items-center text-white'
                                        onClick={() => trackGAEvent(GA_EVENTS.HOME_PHONE_CONTACT, 'Contact', 'Phone Click')}
                                    >
                                        <img src={phone} className='footer-icon-home me-2' alt="" />

                                        <span className='d-none d-lg-inline text-white'>+1 (216) 678-6887
                                        </span>
                                        <span className='d-lg-none text-white'>+1 (216) 678-6887
                                        </span>
                                    </a>
                                </button>

                                <button className="btn contact-btn-2 py-1 d-flex align-items-center justify-content-center mx-2 p-2">
                                    <a
                                        className="nav-link text-decoration-none px-0 p-0 d-flex align-items-center text-white"
                                        href="mailto:hello@probillrcm.com"
                                        onClick={() => trackGAEvent(GA_EVENTS.HOME_EMAIL_CONTACT, 'Contact', 'Email Click')}
                                    >
                                        <img src={inbox} className='footer-icon-home me-2' alt="" />

                                        hello@probillrcm.com
                                    </a>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                <div
                    className={`step-bg-img animate-section ${animatedSections.has(6) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[6] = el}
                    data-section-index="6"
                >
                    <div className="container mt-lg-5 mt-4 mb-lg-0 mb-3">
                        <div className="row d-flex align-items-center justify-content-center">
                            <div className="col-lg-5 col-12 mt-lg-0 mt-2">
                                <div className="row">
                                    <div className="col-12">
                                        <h2 className="contact-text  m-0 mt-lg-0 mt-0 text-md-start text-center">
                                            Simplifying Revenue with Trusted Expertise</h2>
                                        <p className="bridge-card-desc text-start" style={{ fontSize: "15px" }}>
                                            At{" "}<b>
                                                <a
                                                    href="https://probillrcm.com/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "inherit", textDecoration: "none" }}
                                                >
                                                    ProBill RCM
                                                </a></b>
                                            , we’re committed to helping healthcare providers strengthen cash flow with expert billing and collection services that take the pressure off your team so you can focus on patient care.
                                        </p>                                    </div>
                                    <div className="col-md-auto col-12 mb-4 mb-md-0  d-flex align-items-center justify-content-md-start justify-content-center">
                                        <div className="row">
                                            <Link
                                                to="/#contactUs-form"
                                                onClick={() => {
                                                    handleShow();
                                                    trackGAEvent(GA_EVENTS.HOME_EXPLORE_MORE, 'CTA', 'Services Section');
                                                }}
                                                className=" text-decoration-none w-auto"
                                            >
                                                <div className="d-flex justify-content-center justify-content-md-start add_btn_format_circle_hover">
                                                    <button
                                                        className="ps-3 add_btn_format ms-4 ms-md-0 fw-semibold py-2"
                                                        id="/#contactUs-form"
                                                        onClick={() => {
                                                            handleShow();
                                                            trackGAEvent(GA_EVENTS.HOME_EXPLORE_MORE, 'CTA', 'Services Section');
                                                        }}
                                                    >
                                                        Explore More{" "}
                                                    </button>
                                                    <div className="d-flex align-items-center justify-content-center add_btn_format_circle">
                                                        {/* <ImArrowRight2 className="fw-bold arrow_icon" /> */}
                                                        <ImArrowUpRight2 className="fw-bold arrow_icon" />
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-12 d-lg-flex justify-content-lg-end ps-md-5 industry-cards-containers d-none">
                                <div className="row d-flex aling-items-center">
                                    <div className="col-4 pe-0 industry-column-11"
                                        style={{ marginTop: "100px", }}
                                    >
                                        <div className="row">

                                            <div className="col-12 mb-3">
                                                <div
                                                    className="border-0 shadow-sm overflow-hidden h-100 industry-card card"

                                                >
                                                    <Link
                                                        to="/industries/credentialing"
                                                        className="text-decoration-none"
                                                        onClick={() => trackGAEvent(GA_EVENTS.SERVICE_CREDENTIALING, 'Service Card', 'Home Page')}
                                                    >

                                                        <div className="position-relative" style={{ cursor: "pointer" }}>
                                                            <img
                                                                className="card-img img-fluid object-fit-cover"
                                                                src={topview}
                                                                alt="certified provider credentialing specialist"
                                                                loading="lazy"
                                                                style={{ height: "230px", transition: "transform 0.3s ease-out", cursor: "pointer" }}
                                                            />
                                                            <img className="position-absolute top-0 w-100 h-100 object-fit-cover" style={{ transform: "translate(-118px, 0px)" }} src={gridentcolor} alt="gradient" />
                                                            <div className="position-absolute bottom-0 w-100 text-white p-3 fw-semibold text-start">
                                                                <h3 className="add_heading_industry text-start text-white mb-3 fw-bold">Credentialing & Enrollment</h3>
                                                                <p className=" add_para_industry text-start my-0">
                                                                    From initial applications to contract maintenance, we manage the entire enrollment lifecycle to secure faster approvals and uninterrupted billing privileges.                                                         </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-4 pe-0 industry-column-11">
                                        <div className="row">
                                            <div className="col-12 mb-3">
                                                <div
                                                    className="border-0 shadow-sm overflow-hidden h-100 industry-card card"

                                                >
                                                    <Link
                                                        to="/industries/denial-management"
                                                        className="text-decoration-none"
                                                        onClick={() => trackGAEvent(GA_EVENTS.SERVICE_DENIAL_MANAGEMENT, 'Service Card', 'Home Page')}
                                                    >
                                                        <div className="position-relative" style={{ cursor: "pointer" }}>
                                                            <img
                                                                className="card-img img-fluid object-fit-cover"
                                                                src={entre}
                                                                alt="denial management in healthcare"
                                                                loading="lazy"
                                                                style={{ height: "210px", transition: "transform 0.3s ease-out" }}
                                                            />
                                                            <img className="position-absolute top-0 w-100 h-100 object-fit-cover" style={{ transform: "translate(-118px, 0px)" }} src={gridentcolor} alt="gradient" />
                                                            <div className="position-absolute bottom-0 w-100 text-white p-3 fw-semibold text-start">
                                                                <h3 className="add_heading_industry text-start text-white mb-3 fw-bold">Denial Management Services</h3>
                                                                <p className=" add_para_industry text-start my-0">
                                                                    We resolve claim denials quickly and effectively, helping you recover revenue and prevent future rejections.                                                        </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="col-12 mb-3">
                                                <div
                                                    className="border-0 shadow-sm overflow-hidden h-100 industry-card card"

                                                >
                                                    <Link
                                                        to="/industries/account-reconciliation"
                                                        className="text-decoration-none"
                                                        onClick={() => trackGAEvent(GA_EVENTS.SERVICE_ACCOUNT_RECONCILIATION, 'Service Card', 'Home Page')}
                                                    >
                                                        <div className="position-relative " style={{ cursor: "pointer" }}>
                                                            <img
                                                                className="card-img img-fluid object-fit-cover"
                                                                src={topview}
                                                                alt="Account Reconciliation Services"
                                                                loading="lazy"
                                                                style={{ height: "210px", transition: "transform 0.3s ease-out" }}
                                                            />
                                                            <img className="position-absolute top-0 w-100 h-100 object-fit-cover" style={{ transform: "translate(-118px, 0px)" }} src={gridentcolor} alt="gradient" />
                                                            <div className="position-absolute bottom-0 w-100 text-white p-3 fw-semibold text-start">
                                                                <h3 className="add_heading_industry text-start text-white mb-3 fw-bold">Account Reconciliation</h3>
                                                                <p className=" add_para_industry text-start my-0">
                                                                    We match payments with claims and spot discrepancies fast so your books stay balanced and revenue stays protected.                                                        </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-4 industry-column-12 mt-5">
                                        <div className="row mt-4">
                                            <div className="col-12 mb-3">
                                                <div
                                                    className="border-0 shadow-sm overflow-hidden h-100 industry-card card"

                                                >
                                                    <Link
                                                        to="/industries/accounts-receivable"
                                                        className="text-decoration-none"
                                                        onClick={() => trackGAEvent(GA_EVENTS.SERVICE_ACCOUNTS_RECEIVABLE, 'Service Card', 'Home Page')}
                                                    >

                                                        <div className="position-relative" style={{ cursor: "pointer" }}>
                                                            <img
                                                                className="card-img img-fluid object-fit-cover"
                                                                src={dentist}
                                                                alt="receivable management services"
                                                                loading="lazy"
                                                                style={{ height: "210px", transition: "transform 0.3s ease-out" }}
                                                            />
                                                            <img className="position-absolute top-0 w-100 h-100 object-fit-cover" style={{ transform: "translate(-110px, 0px)" }} src={gridentcolor} alt="gradient" />
                                                            <div className="position-absolute bottom-0 w-100 text-white p-3 fw-semibold text-start">
                                                                <h3 className="add_heading_industry text-start text-white mb-3 fw-bold">Accounts Receivable</h3>
                                                                <p className=" add_para_industry text-start my-0">
                                                                    We track and manage your outstanding claims, accelerating collections and keeping your revenue on schedule.                                                      </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="col-12 mb-3">
                                                <div
                                                    className="border-0 shadow-sm overflow-hidden h-100 industry-card card"

                                                >
                                                    <Link
                                                        to="/industries/charge-entry-audit"
                                                        className="text-decoration-none"
                                                        onClick={() => trackGAEvent(GA_EVENTS.SERVICE_CHARGE_ENTRY_AUDIT, 'Service Card', 'Home Page')}
                                                    >
                                                        <div className="position-relative" style={{ cursor: "pointer" }}>
                                                            <img
                                                                className="card-img img-fluid object-fit-cover"
                                                                src={shipping}
                                                                alt="Charge Entry and Charge Audit"
                                                                loading="lazy"
                                                                style={{ height: "210px", transition: "transform 0.3s ease-out" }}
                                                            />
                                                            <img className="position-absolute top-0 w-100 h-100 object-fit-cover" style={{ transform: "translate(-110px, 0px)" }} src={gridentcolor} alt="gradient" />
                                                            <div className="position-absolute bottom-0 w-100 text-white p-3 fw-semibold text-start">
                                                                <h3 className="add_heading_industry text-start text-white mb-3 fw-bold">Charge entry &-Audit                                                </h3>
                                                                <p className=" add_para_industry text-start my-0 ">
                                                                    Accurate charge entry and audits ensure clean claims and faster reimbursements, with zero guesswork.                                                        </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div
                                                    className="border-0 shadow-sm overflow-hidden h-100 industry-card card"

                                                >
                                                    <Link
                                                        to="/industries/payment-posting"
                                                        className="text-decoration-none"
                                                        onClick={() => trackGAEvent(GA_EVENTS.SERVICE_PAYMENT_POSTING, 'Service Card', 'Home Page')}
                                                    >
                                                        <div className="position-relative" style={{ cursor: "pointer" }}>
                                                            <img
                                                                className="card-img img-fluid object-fit-cover"
                                                                src={wiretransfer}
                                                                alt="medical billing outsourcing"
                                                                loading="lazy"
                                                                style={{ height: "210px", transition: "transform 0.3s ease-out" }}
                                                            />
                                                            <img className="position-absolute top-0 w-100 h-100 object-fit-cover" style={{ transform: "translate(-110px, 0px)" }} src={gridentcolor} alt="gradient" />
                                                            <div className="position-absolute bottom-0 w-100 text-white p-3 fw-semibold text-start">
                                                                <h3 className="add_heading_industry text-start text-white mb-3 fw-bold">Payment Posting</h3>
                                                                <p className=" add_para_industry text-start my-0">
                                                                    Payments are posted accurately and promptly, giving you clear visibility into your revenue cycle.                                                        </p>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className="col-lg-6 col-12 d-lg-none d-block justify-content-lg-end ps-md-5">
                                <div className="row align-items-center">
                                    {/* Each card occupies col-6 for 2 cards per row */}
                                    <div className="col-6 mb-2 pe-1">
                                        <div className="border-0 shadow-sm overflow-hidden h-100 industry-card card">
                                            <div className="position-relative">
                                                <img
                                                    className="card-img img-fluid object-fit-cover"
                                                    src={entre}
                                                    alt="Denial Management Services"
                                                    loading="lazy"
                                                    style={{ height: "190px", transition: "transform 0.3s ease-out" }}
                                                />
                                                <img
                                                    className="position-absolute top-0 w-100 h-100 object-fit-cover"
                                                    style={{ left: "0px", right: "0px" }}
                                                    src={gridentcolor}
                                                    alt="gradient"
                                                />
                                                <div className="position-absolute bottom-0 w-100 text-white p-2 fw-semibold text-start">
                                                    <h3 className="add_heading_industry mb-1 fw-bold text-white">Denial Management Services</h3>
                                                    <p className="add_para_industry my-0">
                                                        We resolve claim denials quickly and effectively, helping you recover revenue and prevent future rejections.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6 mb-2 ps-1">
                                        <div className="border-0 shadow-sm overflow-hidden h-100 industry-card card">
                                            <div className="position-relative">
                                                <img
                                                    className="card-img img-fluid object-fit-cover"
                                                    src={topview}
                                                    alt="Account Reconciliation"
                                                    loading="lazy"
                                                    style={{ height: "190px", transition: "transform 0.3s ease-out" }}
                                                />
                                                <img
                                                    className="position-absolute top-0 w-100 h-100 object-fit-cover"
                                                    style={{ left: "0px", right: "0px" }}
                                                    src={gridentcolor}
                                                    alt="gradient"
                                                />
                                                <div className="position-absolute bottom-0 w-100 text-white p-2 fw-semibold text-start">
                                                    <h3 className="add_heading_industry mb-1 fw-bold text-white">Account Reconciliation</h3>
                                                    <p className="add_para_industry my-0">
                                                        We match payments with claims and spot discrepancies fast so your books stay balanced and revenue stays protected.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6 mb-2 pe-1">
                                        <div className="border-0 shadow-sm overflow-hidden h-100 industry-card card">
                                            <div className="position-relative">
                                                <img
                                                    className="card-img img-fluid object-fit-cover"
                                                    src={dentist}
                                                    alt="Accounts Receivable"
                                                    loading="lazy"
                                                    style={{ height: "190px", transition: "transform 0.3s ease-out" }}
                                                />
                                                <img
                                                    className="position-absolute top-0 w-100 h-100 object-fit-cover"
                                                    style={{ left: "0px", right: "0px" }}
                                                    src={gridentcolor}
                                                    alt="gradient"
                                                />
                                                <div className="position-absolute bottom-0 w-100 text-white p-2 fw-semibold text-start">
                                                    <h3 className="add_heading_industry mb-1 fw-bold text-white">Accounts Receivable</h3>
                                                    <p className="add_para_industry my-0">
                                                        We track and manage your outstanding claims, accelerating collections and keeping your revenue on schedule.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6 mb-2 ps-1 ">
                                        <div className="border-0 shadow-sm overflow-hidden h-100 industry-card card">
                                            <div className="position-relative">
                                                <img
                                                    className="card-img img-fluid object-fit-cover"
                                                    src={shipping}
                                                    alt="Charge entry & Audit"
                                                    loading="lazy"
                                                    style={{ height: "190px", transition: "transform 0.3s ease-out" }}
                                                />
                                                <img
                                                    className="position-absolute top-0 w-100 h-100 object-fit-cover"
                                                    style={{ left: "0px", right: "0px" }}
                                                    src={gridentcolor}
                                                    alt="gradient"
                                                />
                                                <div className="position-absolute bottom-0 w-100 text-white p-2 fw-semibold text-start">
                                                    <h3 className="add_heading_industry mb-1 fw-bold text-white">Charge entry & Audit</h3>
                                                    <p className="add_para_industry my-0">
                                                        Accurate charge entry and audits ensure clean claims and faster reimbursements, with zero guesswork.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div
                    className={`container mt-lg-0 mt-2 card-bg-vector animate-section position-relative ${animatedSections.has(7) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[7] = el}
                    data-section-index="7"
                >

                    <div className="row mx-auto border-top pt-md-2">
                        <div className="col-lg-8 col-12 mt-3 mt-lg-5 text-start">
                            <h2 className=" text-dark text-probill-rcm m-0 mt-lg-0 mt-2 ">Stories That   <span className="text-probill-rcm-orange">Drive Innovation</span></h2>
                            <p className='mt-lg-3 mt-1 text-probill-para m-0'>Stories That Drive Innovation
                                Client experiences that continue to shape and strengthen our healthcare solutions. </p>
                        </div>
                        <div className="col-lg-4 mt-lg-5 mt-3 col-12 text-lg-end text-center">
                            {/* <h5 className='me-0 fw-semibold mb-2' style={{ fontSize: "24px", lineHeight: "40px" }}><img src={onestart} alt="" style={{ width: "27px", height: "27px" }} /> Trustpilot</h5> */}
                            <div className="d-flex justify-content-lg-end justify-content-center align-items-end">
                                <div className="d-flex justify-content-between ">

                                    <div className="div star mx-1 d-flex align-item-center ">
                                        <img src={start} className='mx-auto img-fluid' style={{ objectFit: 'fill' }} alt="" />
                                    </div>
                                    <div className="div star mx-1 d-flex align-item-center">
                                        <img src={start} className='mx-auto img-fluid' style={{ objectFit: 'fill' }} alt="" />
                                    </div>
                                    <div className="div star mx-1 d-flex align-item-center">
                                        <img src={start} className='mx-auto img-fluid' style={{ objectFit: 'fill' }} alt="" />
                                    </div>
                                    <div className="div star mx-1 d-flex align-item-center">
                                        <img src={start} className='mx-auto img-fluid' style={{ objectFit: 'fill' }} alt="" />
                                    </div>
                                    <div className="div star mx-1 d-flex align-item-center me-0">
                                        <img src={start} className='mx-auto img-fluid' style={{ objectFit: 'fill' }} alt="" />
                                    </div>

                                </div>
                            </div>
                            {/* <p className='my-0' style={{ fontSize: "14px", lineHeight: "40px", color: "#474d5cff" }}>Trust Score 5.0 | 3,724 reviews</p> */}
                        </div>
                    </div>

                </div>
                <div
                    className={`container-fluid mt-lg-0 animate-section ${animatedSections.has(8) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[8] = el}
                    data-section-index="8"
                >
                    <div className="row mx-auto card-bg-vect">
                        <div className="quote-symbol-container-first px-5 d-none d-md-flex" style={{ position: 'absolute', left: 0, top: "0px", zIndex: 0, }}>
                            <img src={card_vector} className="quote-symbol" alt="quote" />
                            <img src={card_vector} className="quote-symbol" alt="quote" />
                        </div>

                        <div
                            className="container-fluid mt-lg-5 animate-section"
                            ref={containerRef}
                            style={{ overflow: 'hidden', padding: '20px 0' }}
                        >
                            <div className="row mx-auto card-bg-vect" style={{ position: 'relative' }}>
                                <div
                                    className="d-flex"
                                    onMouseEnter={() => setIsAutoPlaying(false)}
                                    onMouseLeave={() => setIsAutoPlaying(true)}
                                    style={{
                                        transform: `translateX(-${currentIndex * CARD_WIDTH}px)`,
                                        transition: currentIndex >= testimonials.length ? 'none' : 'transform 0.5s ease-in-out',
                                        gap: '16px',
                                        willChange: 'transform',
                                    }}
                                >
                                    {infiniteTestimonials.map((testimonial, index) => (
                                        <Card
                                            key={`${testimonial.name}-${index}`}
                                            className="h-100 slide-card"
                                            style={{
                                                borderRadius: '20px',
                                                minWidth: `${CARD_WIDTH - 16}px`,
                                                maxWidth: `${CARD_WIDTH - 16}px`,
                                                flexShrink: 0,
                                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                            }}
                                        >
                                            <Card.Body className="d-flex flex-column mt-md-4 mt-0 px-4">
                                                <h3 className="text-start m-0 card-heading text-dark">{testimonial.title}</h3>
                                                <Card.Text className="text-muted text-start insight-desc flex-grow-1">
                                                    {testimonial.quote}
                                                </Card.Text>
                                                <div className="d-flex align-items-center mt-3 mb-3">
                                                    <img
                                                        src={testimonial.img}
                                                        alt={testimonial.name}
                                                        className="rounded-5 me-3 card-user-img"
                                                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                    />
                                                    <div className="text-start">
                                                        <h4 className="mb-0 text-dark m-0 card-user-name">{testimonial.name}</h4>
                                                        <span className="text-muted mb-0 card-rating">{testimonial.role}</span>
                                                    </div>
                                                    <div className="ms-auto mt-2 mx-0 align-items-center">
                                                        <div className="d-flex align-items-center">
                                                            <img
                                                                src={onestart}
                                                                alt="Star"
                                                                className="m-0"
                                                                style={{ width: '20px', height: '20px' }}
                                                            />
                                                            <span
                                                                className="ms-1 text-dark m-0"
                                                                style={{ fontWeight: '600', fontFamily: 'poppins', fontSize: '16px' }}
                                                            >
                                                                {testimonial.rating}
                                                            </span>
                                                        </div>
                                                        <span className="text-muted card-rating">Rating</span>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </div>
                            </div>

                            <div className="container mt-lg-5 mt-4">
                                <div className="row mx-auto mb-lg-5 mb-3">
                                    <div className="d-flex col-lg-12 col-12 gap-2 align-items-center justify-content-center">
                                        <Button onClick={handlePrev} disabled={currentIndex === 0} className="btn fw-bold bg-white rounded-5 text-dark border-white shadow ">
                                            <i className="bi bi-arrow-left fw-bold"></i>
                                        </Button>
                                        <Button onClick={handleNext} disabled={currentIndex >= testimonials.length - visibleCards} className="btn bg-white text-dark border-white shadow fw-bold">
                                            <i className="bi bi-arrow-right"></i>
                                        </Button>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div className="frame mt-lg-0  ">
                    <div className="container mt-lg-1 px-0">
                        <div className="row mx-auto mt-0 mt-lg-0 py-md-5 py-0">
                            <div className="col-lg-12 m-0 col-12  mt-0  text-lg-start flex-column d-flex justify-content-center">
                                <h2 className='text-white contact-text  m-0 mt-lg-0 mt-4'>
                                    Turning Performance Into <span className='contact-text-orange add_grident_font'>Patient-Centered Progress</span>

                                </h2>
                            </div>
                            <div className="row g-4 justify-content-center pb-3 mx-auto px-0">
                                {/* Card 1 */}
                                <div className="col-md-4 mt-0">
                                    <div className="stat-card text-start text-white pb-md-3 pb-0 pt-md-3 pt-3">
                                        <h3 className="stat-title text-start mb-0">Up to</h3>
                                        <div className='col-12'>
                                            <div className='row'>
                                                <div className='col-auto'>
                                                    <h3 className='fw-bold add_font_size text-white'>15%</h3>
                                                </div>
                                                <div className='col-md-7 col-9 d-flex align-items-center'>
                                                    <p className="stat-text mb-0"> Reduction in Cost - to collection</p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Card 2 */}
                                <div className="col-md-4 mt-0">
                                    <div className="stat-card text-start text-white pb-md-3 pb-0 pt-md-3 pt-3">
                                        <h3 className="stat-title text-start mb-0">Up to </h3>
                                        <div className='col-12'>
                                            <div className='row'>
                                                <div className='col-auto'>
                                                    <h3 className='fw-bold add_font_size text-white'>1-4%</h3>

                                                </div>
                                                <div className='col-md-5 col-8 d-flex align-items-center'>
                                                    <p className="stat-text mb-0">Revenue Improvement</p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Card 3 */}
                                <div className="col-md-4 mt-0">
                                    <div className="stat-card text-start text-white pb-md-3 pb-0 pt-md-3 pt-3">
                                        <h3 className="stat-title text-start mb-0">Up to </h3>
                                        <div className='col-12'>
                                            <div className='row'>
                                                <div className='col-auto'>
                                                    <h3 className='fw-bold add_font_size text-white'>15%</h3>
                                                </div>
                                                <div className='col-md-5 col-8 d-flex align-items-center'>
                                                    <p className="stat-text mb-0">Garneted cost reduction</p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section
                    className={`faq-section py-md-5 py-0 animate-section ${animatedSections.has(10) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[10] = el}
                    data-section-index="10"
                >
                    <div className="container py-md-4 border-bottom">
                        <div className="row align-items-start pb-md-5 pb-4">
                            <div className="col-lg-5 my-0 d-flex align-items-center align-items-md-start justify-content-center  flex-column">

                                <div className="col-lg-12 m-0 col-12  mt-0  text-lg-start flex-column d-flex justify-content-center mb-4">
                                    <h2 className='text-black contact-text  m-0 mt-lg-0 mt-4'>
                                        Frequently <span className='contact-text-orange add_grident_font' style={{ borderBottom: "4px solid #b95b1d" }}>Asked Question</span>

                                    </h2>
                                </div>
                                <p className="faq-subtitle text-start">
                                    Get quick, reliable answers to your questions about our RCM
                                    solutions from processes and technology.
                                </p>
                                <button
                                    className="btn contact-btn d-flex align-items-center justify-content-center w-auto "
                                    onClick={() => {
                                        handleShow();
                                        trackGAEvent(GA_EVENTS.HOME_CONTACT_US_FAQ, 'CTA', 'FAQ Section');
                                    }}
                                >
                                    Contact Us<i class="bi bi-arrow-right-short fs-3"></i>
                                </button>
                            </div>

                            {/* Right Side */}
                            <div className="col-lg-7 ps-md-5">
                                <Accordion activeKey={activeKey1} className='ps-md-5'>
                                    {[
                                        {
                                            q: "What is Probill RCM and how does it help healthcare providers?",
                                            a: "Probill RCM is an end-to-end revenue cycle management platform designed to streamline billing, coding, and collections ensuring faster payments and fewer denials for your practice."
                                        },
                                        {
                                            q: "Can Probill RCM integrate with our current EMR/EHR system?",
                                            a: "Yes. Probill RCM is compatible with most major EMR/EHR systems and can be customized for seamless integration to avoid workflow disruption. "
                                        },
                                        {
                                            q: "How secure is Probill RCM with patient data?",
                                            a: "We provide HIPAA compliant software backed by enterprise-grade encryption and robust access controls to ensure the highest level of data privacy and security. "
                                        },
                                        {
                                            q: "How long does it take to see results after implementation?",
                                            a: "Most clients notice improvements in claim turnaround, collections, and denial rates within the first 30-90 days post-implementation. "
                                        }
                                    ].map((item, index) => (
                                        <Accordion.Item eventKey={String(index)} key={index} className='add_border_bottom'>
                                            <Accordion.Header
                                                onClick={() => toggleKey1(String(index))}
                                                className="custom-header"
                                            >
                                                <h3 className="custom-header">   {item.q}</h3>
                                                <span className="icon">
                                                    {activeKey1 === String(index) ? (
                                                        <FaMinus />
                                                    ) : (
                                                        <FaPlus />
                                                    )}
                                                </span>
                                            </Accordion.Header>
                                            <Accordion.Body>{item.a}</Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </section>
                <section
                    className={`pb-md-5 pb-4 pt-0 rcm-section step-bg-img animate-section ${animatedSections.has(11) ? 'visible' : ''}`}
                    ref={el => sectionRefs.current[11] = el}
                    data-section-index="11"
                >
                    <Container>
                        <Row className="align-items-center">
                            <Col lg={6} className="mb-4 pe-lg-6">
                                <div className="col-lg-12 m-0 col-12  mt-0  text-lg-start flex-column d-flex justify-content-center">
                                    <h2 className='text-black contact-text  m-0 mt-lg-0 mt-4'>
                                        What Sets Our Emergency <span className='contact-text-orange add_grident_font'>Medicine RCM Apart</span>

                                    </h2>
                                </div>

                                <Accordion activeKey={activeKey2} className='ps-md-0 mt-4'>
                                    {[
                                        {
                                            q: "The Probill RCM Way",
                                            a: "At Probill, we do more than manage your revenue cycle; we become part of your team. Our tailored approach helps you increase profitability, accelerate payments, and work more efficiently. With our experts by your side, you'll gain clear visibility, powerful reporting, and insights that drive real results."
                                        },
                                        {
                                            q: "High-Performance Technology",
                                            a: "Our platform is built on cutting-edge technology designed specifically for emergency medicine workflows. From AI-driven claims scrubbing to real-time analytics, we help reduce errors, improve accuracy, and accelerate reimbursements.  "
                                        },
                                        {
                                            q: "Decades of Niche Experience",
                                            a: "Probill brings deep expertise in emergency medicine billing and coding. Our team understands the complexities of high-volume, fast-paced ER environments, and the unique challenges they face from split billing to out-of-network reimbursements.  "
                                        },
                                        {
                                            q: "Financial Clarity and Prosperity ",
                                            a: "We don’t just manage your revenue, we give you full visibility into it. Our customized dashboards, detailed reporting, and dedicated account managers ensure you always know where you stand financially. With us, you gain not just clarity, but confidence and control over your cash flow, helping you plan and grow effectively. "
                                        }
                                    ].map((item, index) => (
                                        <Accordion.Item
                                            eventKey={String(index)}
                                            key={index}
                                            className={activeKey2 === String(index) ? '' : 'add_border_bottom'}
                                            style={activeKey2 === String(index) ? {
                                                border: '1px solid transparent',
                                                background: 'linear-gradient(white, white) padding-box, linear-gradient(45deg, #F37016, #B1510F) border-box',
                                                borderRadius: '12px'
                                            } : {}}
                                        >
                                            <Accordion.Header
                                                onClick={() => toggleKey2(String(index))}
                                                className={`custom-header px-3 ${activeKey2 === String(index) ? 'no-bottom-border' : ''}`}
                                            >
                                                <h3 className="custom-header">   {item.q}</h3>
                                                <span className="icon">
                                                    {activeKey2 === String(index) ? (

                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>) : (
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>)}
                                                </span>
                                            </Accordion.Header>
                                            <Accordion.Body className='accordion_second pt-0'>{item.a}</Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </Col>

                            <Col lg={6} className="d-flex gap-3 justify-content-center flex-wrap ps-lg-5">

                                <div className="doctor-card">
                                    <img
                                        src={rcmapart}
                                        alt="medical billing services"
                                        className="img-fluid rounded"
                                    />
                                </div>
                            </Col>
                        </Row>


                    </Container>
                    <Container className='pt-md-5 pt-4 pb-md-3 pb-0'>
                        <div class="bg_img_Add">
                            <div class="container">
                                <div class="row mx-auto">
                                    <div class="col-md-12 col-12 mx-auto">
                                        <div class="row"><div class="col-md-9 col-12">
                                            <h2 class="mb-0 fw-semibold text-white add_font_bg_section text-center text-md-start fs-2">Looking to learn more about us? It all starts here. </h2>
                                        </div>
                                            <div className=" col-md-3 col-12 mt-3 mt-md-0 d-flex justify-content-center justify-content-md-end add_btn_format_circle_hover">

                                                <button
                                                    className="btn d-flex align-items-center justify-content-center add_padding_font"
                                                    onClick={() => {
                                                        handleShow();
                                                        trackGAEvent(GA_EVENTS.HOME_TALK_TO_EXPERT, 'CTA', 'Bottom Section');
                                                    }}
                                                    type="button"
                                                    style={{
                                                        background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                                        color: "white",
                                                        borderRadius: "12px",
                                                        padding: "4px 24px",
                                                        border: "none",
                                                        fontWeight: "500",
                                                        fontSize: "16px",
                                                        // boxShadow: "0 2px 8px rgba(233, 114, 14, 0.3)"
                                                    }}
                                                >
                                                    Talk to an expert<i class="bi bi-arrow-right-short fs-3"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </section>


                <Modal show={showModal} onHide={handleClose} centered size="xl">
                    {/* Close Button in Top-Right Corner */}
                    <button
                        type="button"
                        className="btn-close position-absolute"
                        style={{
                            top: "11px",
                            right: "11px",
                            zIndex: 1051,
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            padding: "6px",
                            fontSize: "15px",
                            // border: "2px solid black",
                        }}
                        aria-label="Close"
                        onClick={handleClose}
                    ></button>

                    <Modal.Body className="p-4">
                        <div className="container-fluid">
                            <div className="row d-flex justify-content-center align-items-center">
                                <div className="col-lg-6 d-none d-lg-block">
                                    <div className="image-container">
                                        <img
                                            src={external1}
                                            alt="Team Working"
                                            className="w-100 h-100 diagonal-image"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 ps-md-4 ps-0">
                                    {isSubmitted ? (
                                        <div className="text-center">
                                            <h1 className="hero-text mt-0">
                                                Thank <span className="text-orange add_grident_font" style={{ color: "#E9720E" }}>You!</span> <br />
                                            </h1>
                                            <p>for submitting your information! Our representative will reach out to you shortly.</p>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="d-flex m-0 modal-heading justify-content-between">
                                                <h1>
                                                    How can we <span style={{ color: "#E27239" }}>help you?</span>
                                                </h1>
                                                {/* Remove this old close button if not needed */}
                                                {/* <button
                                    type="button"
                                    className="btn-close d-lg-none d-block"
                                    onClick={handleClose}
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button> */}
                                            </div>
                                            <p className="fs-6 m-0 d-lg-none" style={{ color: "#2A3040" }}>
                                                Within 24 hours, a representative from our company will contact you.
                                            </p>
                                            <form onSubmit={handleSubmit(onSubmit)} className="mt-0">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-medium text-start d-block">Name</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter your Full Name"
                                                            className={`custom_control py-2 form-control ${errors.fullName ? "is-invalid" : ""}`}
                                                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                                                            {...register("fullName", { required: "Full Name is required" })}
                                                        />
                                                        {errors.fullName && (
                                                            <p className="text-danger">{errors.fullName.message}</p>
                                                        )}
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-medium text-start d-block">Email</label>
                                                        <input
                                                            type="email"
                                                            placeholder="Enter your Email"
                                                            className={`custom_control py-2 form-control ${errors.email ? "is-invalid" : ""}`}
                                                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                                                            {...register("email", {
                                                                required: "Email is required",
                                                                pattern: {
                                                                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                                                    message: "Please enter a valid email address"
                                                                }
                                                            })}
                                                        />
                                                        {errors.email && (
                                                            <p className="text-danger">{errors.email.message}</p>
                                                        )}
                                                    </div>

                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label fw-medium text-start d-block">Subject</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Subject"
                                                            className={`custom_control py-2 form-control ${errors.subject ? "is-invalid" : ""}`}
                                                            style={{ border: "1px solid #A4A4A480", height: "48px" }}
                                                            {...register("subject", {
                                                                required: "Subject is required",
                                                                minLength: {
                                                                    value: 3,
                                                                    message: "Subject should be at least 3 characters long"
                                                                }
                                                            })}
                                                        />
                                                        {errors.subject && (
                                                            <p className="text-danger">{errors.subject.message}</p>
                                                        )}
                                                    </div>

                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label fw-medium text-start d-block">Message</label>
                                                        <textarea
                                                            className={`custom_control py-2 form-control ${errors.message ? "is-invalid" : ""}`}
                                                            style={{ border: "1px solid #A4A4A480" }}
                                                            rows="7"
                                                            placeholder="Brief us on your requirements"
                                                            {...register("message", {
                                                                required: "Message is required",
                                                                minLength: {
                                                                    value: 10,
                                                                    message: "Message should be at least 10 characters long"
                                                                }
                                                            })}
                                                        ></textarea>
                                                        {errors.message && (
                                                            <p className="text-danger">{errors.message.message}</p>
                                                        )}
                                                    </div>

                                                    <div className="col-md-12 mt-3">
                                                        <button
                                                            type="submit"
                                                            className="btn col-12"
                                                            style={{
                                                                background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                                                                color: "white",
                                                                borderRadius: "12px",
                                                                padding: "12px 24px",
                                                                border: "none",
                                                                fontWeight: "500",
                                                                fontSize: "16px"
                                                            }}
                                                            disabled={isSubmitting}
                                                            onClick={() => trackGAEvent(GA_EVENTS.FORM_SUBMIT_HOME, 'Form', 'Home Modal')}
                                                        >
                                                            {isSubmitting ? "SENDING..." : "Submit Now"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

            </section>
        </>
    );
}
export default Section;
